<template>
  <div id="container">
    <div
      class="item-box-content"
      style="padding:14px 20px;">
      <span
        class="title-font-style"
        style="margin-bottom:0px;">资金占用比例设置</span>
    </div>
    <div class="item-box-content">
      <span class="title-font-style">设置</span>
      <el-form
        ref="form"
        style="padding-left: 30px">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item>每日占用金额：
              <el-input
                v-model="value"
                :disabled="isflag"
                type="number"
                style="width:200px;"
                placeholder="请输入占用金额">
              </el-input>
              <span style="padding-left: 10px;">%</span></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            type="info"
            style="background: #fff;border-color: #DCDFE6;color: #4E555B"
            v-show="isflag"
            @click="updataSystemData"
            plain
          >修改
          </el-button>
          <el-button
            style="margin:0;"
            type="primary"
            v-show="!isflag"
            @click="toSave">保存
          </el-button>
        </el-row>
      </el-form>
      <div
        class="title_info"
        style="padding-left: 30px;">*说明：合同在未完全回款情况下，备货而产生的资金占用所收取的费用设置。
      </div>
    </div>
  </div>
</template>
<script>
  import { expressionList } from '@/components/utils/data'
  import { queryFinanceSetting, updateOccupancyRatio } from '@/api/system/rightsManagement'
  import { isSuccess } from '@/util/tool'
  import NP from 'number-precision'

  export default {
    name: 'fundOccupation',
    data () {
      return {
        queryParams: {},
        value: 0,
        contractScreenCondition: [],
        expressionList: expressionList,
        loadingTable: false, // 列表loading
        list: [{}], // 列表数据
        pageSize: 30, // 页数
        currentPage: 1, // 页码
        total: 0, // 列表总数
        value1: false,
        value2: true,
        isflag: true
      }
    },
    mounted () {
      queryFinanceSetting().then(res => {
        if (isSuccess(res)) {
          if (res.data.obj && res.data.obj.occupancyRatio) {
            this.value = NP.strip(res.data.obj.occupancyRatio * 100) || ''
          }
        }
      })
    },
    methods: {
      // 保存
      toSave () {
        if (this.value.length === 0) {
          this.$message({
            message: '请填写占用金额',
            type: 'error'
          })
          return
        }
        if (this.value <= 0 || this.value > 100) {
          this.$message({
            message: '系统罚没比例不能小于0，不能大余100',
            type: 'error'
          })
          return
        }
        updateOccupancyRatio(NP.strip(this.value / 100)).then(res => {
          if (isSuccess(res)) {
            this.$message.success('保存成功')
            this.isflag = true
          }
        })
      },
      updataSystemData () {
        this.isflag = false
      },
      // 发起收款
      onInitiateCollection () {
        this.$router.push({ name: 'initiateCollection' })
      },
      // 设置头部背景色
      tableHeader ({ rowIndex }) {
        return this.$tableHeader(rowIndex)
      },
      // 收款申请详情
      onDetails () {
        this.$router.push({ name: 'collectionApplicationDetails' })
      },
      // 页数
      handleSizeChange (val) {
        this.pageSize = val
        this.getList()
      },
      // 页码
      handleCurrentChange (val) {
        this.currentPage = val
        this.getList()
      }
    }
  }
</script>
<style
  lang="scss"
  scoped>
  .title-font-style {
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #4e555b;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .item-box-add .arrive-date {
    display: flex;
  }

  .title_info {
    color: #d35e5e;
    margin-top: 20px;
    font-size: 14px;
  }
</style>
